module.exports = __webpack_public_path__ + "img/card_8.622b7363.png";